// src/services/authService.ts
import axios from "axios";
import { AuthResponse, UserInfo } from "../types";
import { config } from "../config/config";

class AuthService {
  async fetchMe(): Promise<UserInfo> {
    return axios
      .get(`${config.apiUrl}/auth/me`, {
        withCredentials: true,
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error fetching me:", err);
        return null;
      });
  }

  setAuthData(data: AuthResponse): void {
    try {
      localStorage.setItem("authData", JSON.stringify(data));
    } catch (error) {
      console.error("Error saving auth data:", error);
    }
  }

  getAuthData(): AuthResponse | null {
    try {
      const data = localStorage.getItem("authData");
      if (!data) return null;
      const authData = JSON.parse(data) as AuthResponse;
      return authData;
    } catch (error) {
      console.error("Error reading auth data:", error);
      this.clearAuthData();
      return null;
    }
  }

  clearAuthData(): void {
    localStorage.removeItem("authData");
  }

  isAuthenticated(): boolean {
    const authData = this.getAuthData();
    return !!authData?.user_info;
  }

  forceSignIn(): void {
    this.clearAuthData();
    window.location.href = "/login";
  }
}

export const authService = new AuthService();
